var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Box, Text } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import { StoreContext } from '@/app/uistore/Rootstore';
import React from 'react';
import { BaseDialog } from '@/app/UIComponents/BaseDialog';
import { FontSize } from '../const/AppDefaults';
let DisplayRecoveryDialog = class DisplayRecoveryDialog extends React.Component {
    constructor(prop) {
        super(prop);
    }
    dialog() {
        const rstore = this.context;
        return React.createElement(Box, null,
            React.createElement(Box, { style: {
                    marginTop: 50,
                    textAlign: 'center',
                    justifyContent: 'center',
                    alignItems: 'center',
                } },
                React.createElement(Text, { fontSize: FontSize.HeaderFontSize, fontWeight: 'bold' }, rstore.displayRecoveryState.displaysecret),
                React.createElement(Text, { mt: '10px' }, "Please copy this recovery code. If you forget your passowrd you can use recovery code to recover your data and account.")));
    }
    render() {
        const rstore = this.context;
        return (React.createElement(BaseDialog, { body: this.dialog(), state: rstore.displayRecoveryState.basediaglogstate }));
    }
};
DisplayRecoveryDialog.contextType = StoreContext;
DisplayRecoveryDialog = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], DisplayRecoveryDialog);
export { DisplayRecoveryDialog };
